import React from 'react';
import { partners } from '../Partners/PartnersSection';
import './EventPartners.css';

function EventPartners({ partnerIds }) {
    if (!partnerIds || partnerIds.length === 0) {
        return null;
    }

    const eventPartners = partners.filter(partner => partnerIds.includes(partner.name));

    return (
        <div className="event-partners">
            <>
                <h4>Partners</h4>
                <div className="event-partners-grid" data-partners={eventPartners.length}>
                    {eventPartners.map((partner, index) => (
                        <div key={index} className="event-partner-item">
                            <div className="event-partner-logo">
                                <img 
                                    src={partner.logo} 
                                    alt={partner.name}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = '/images/default-partner-logo.png';
                                    }}
                                />
                            </div>
                            <span className="event-partner-name" data-full-name={partner.name}>
                                {partner.name}
                            </span>
                        </div>
                    ))}
                </div>
            </>
        </div>
    );
}

export default EventPartners; 